module.exports = __webpack_public_path__ + "img/basketIcon.cc2a278e.svg";